import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";

export const AsignarCursos = async (serviciosList, email, password) => {
  

  if (email === "" || password === "") {
    toast.warning("No hay email o password para asignar cursos")
    return
  }

  if (serviciosList.length === 0) {
    toast.warning("No hay servicios para asignar")
    return
  }

  const toastId = toast.loading("Creando cuenta en MC Academy y asignando cursos...")

  try {
    const response = await axios.post(`${BACKEND}/api/assign-courses-mc-academy`, {
      email,
      password,
      services: serviciosList.filter((s) => s.servicio.id).map(s => s.servicio.id)
    })

    const message = response?.data?.data?.message
    const status = response?.data?.data?.success ? "success" : "error"

    toast.update(toastId, {
      render: message,
      type: status,
      isLoading: false,
      autoClose: 3000
    }); 

  } catch (error) {
    toast.update(toastId, {
      render: "Error asignando cursos: " + error,
      type: "error",
      isLoading: false,
      autoClose: 3000
    });
  }
}